import { render, staticRenderFns } from "./CompanyFinanceStatBlock.vue?vue&type=template&id=440327ac&scoped=true"
import script from "./CompanyFinanceStatBlock.vue?vue&type=script&lang=js"
export * from "./CompanyFinanceStatBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440327ac",
  null
  
)

export default component.exports